// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddCartTooltip_wrapper__IdCoI","hide":"AddCartTooltip_hide__9p4d5","title":"AddCartTooltip_title__cEN3T","button":"AddCartTooltip_button__1s6L6"};